import type { DashboardDailyPoint } from '../api'

interface Props {
  data: DashboardDailyPoint[]
}

// SVG a mano, sin librería de charts — mismo criterio que Sparkline.tsx
// (mandamiento contra dependencias nuevas para un adorno visual).
export function DashboardBarChart({ data }: Props) {
  if (data.length === 0) {
    return (
      <div className="flex h-56 items-center justify-center text-sm text-muted-foreground">
        No hay mensajes en el período seleccionado.
      </div>
    )
  }

  const height = 200
  const groupWidth = 32
  const barWidth = 9
  const width = Math.max(560, data.length * groupWidth)
  const max = Math.max(1, ...data.flatMap((d) => [d.messages_received, d.messages_responded]))
  const labelEvery = Math.max(1, Math.ceil(data.length / 12))

  return (
    <div className="overflow-x-auto">
      <svg width={width} height={height + 26} className="min-w-full" role="img" aria-label="Mensajes por día">
        <line x1={0} y1={height} x2={width} y2={height} strokeWidth={1} className="stroke-border" />
        {data.map((d, i) => {
          const cx = i * groupWidth + groupWidth / 2
          const receivedH = (d.messages_received / max) * (height - 8)
          const respondedH = (d.messages_responded / max) * (height - 8)
          return (
            <g key={d.date}>
              <rect
                x={cx - barWidth - 1}
                y={height - receivedH}
                width={barWidth}
                height={receivedH}
                rx={2}
                className="fill-indigo-500"
              >
                <title>{`${d.date} · ${d.messages_received} recibidos`}</title>
              </rect>
              <rect
                x={cx + 1}
                y={height - respondedH}
                width={barWidth}
                height={respondedH}
                rx={2}
                className="fill-emerald-500"
              >
                <title>{`${d.date} · ${d.messages_responded} respondidos`}</title>
              </rect>
              {i % labelEvery === 0 && (
                <text x={cx} y={height + 16} textAnchor="middle" className="fill-muted-foreground text-[9px]">
                  {d.date.slice(5)}
                </text>
              )}
            </g>
          )
        })}
      </svg>
    </div>
  )
}
